// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { CustomEvent } from '@shared/utils/CustomEvents';
import { CurrentLang, LOCALE_AR, LOCALE_CH_SM, LOCALE_CH_TR, LOCALE_DE, LOCALE_EN, LOCALE_ES, LOCALE_JA, LOCALE_PL, LOCALE_PT, LOCALE_RU, LocaleNames, Resources, LOCALE_HE } from '@shared/localizations/Resources';
import { LocalStorage } from '../LocalStorage';
import { ApplicationInfo } from '../ApplicationInfo';
class _ResourcesManager {
    constructor() {
        this.onLocaleChange = new CustomEvent();
        this.localeChanged = this.localeChanged.bind(this);
        Resources.subscribeOnLocaleChange(this.localeChanged);
    }
    InitStartLanguage() {
        let lang = this.GetCurrentAppLang();
        LocalStorage.setLanguage(lang);
        if (!lang || lang === 'null') {
            lang = LOCALE_EN;
        }
        Resources.setLocale(lang);
    }
    GetCurrentAppLang() {
        let defLang = ApplicationInfo.LoginLanguage;
        if (defLang) {
            defLang.toLocaleLowerCase();
        }
        if (!defLang) {
            defLang = LOCALE_EN;
        }
        else if (!LocaleNames.includes(defLang)) {
            defLang = LOCALE_EN;
        }
        let storagelang = LocalStorage.getLanguage();
        if (!LocaleNames.includes(storagelang)) {
            storagelang = null;
        }
        return storagelang || defLang;
    }
    getLanguageTag() {
        switch (this.GetCurrentAppLang()) {
            case LOCALE_EN:
                return 'en-GB';
            case LOCALE_ES:
                return 'es-ES';
            case LOCALE_DE:
                return 'de-DE';
            case LOCALE_RU:
                return 'ru-RU';
            case LOCALE_PT:
                return 'pt-PT';
            case LOCALE_AR:
                return 'ar-AE';
            case LOCALE_CH_SM:
                return 'zh-Hans';
            case LOCALE_CH_TR:
                return 'zh-Hant';
            case LOCALE_JA:
                return 'ja-JP';
            case LOCALE_PL:
                return 'pl-PL';
            case LOCALE_HE:
                return 'he-IL';
            default:
                return 'en-GB';
        }
    }
    /* Determines if the current application language is a right-to-left (RTL) language. */
    isRtlLang() {
        const lang = this.GetCurrentAppLang();
        return lang === LOCALE_AR || lang === LOCALE_HE;
    }
    extLinkLocaleName() {
        switch (this.GetCurrentAppLang()) {
            case LOCALE_EN:
                return 'en_GB';
            case LOCALE_PL:
                return 'pl_PL';
            case LOCALE_PT:
                return 'pt_PT';
            case LOCALE_RU:
                return 'ru_RU';
            case LOCALE_JA:
                return 'ja_JP';
            case LOCALE_CH_TR:
                return 'zh_CN';
            case LOCALE_CH_SM:
                return 'zh_CN';
            case LOCALE_AR:
                return 'ar_AE';
            case LOCALE_ES:
                return 'es_ES';
            case LOCALE_DE:
                return 'de_DE';
            default:
                return 'en_GB';
        }
    }
    localeChanged() {
        LocalStorage.setLanguage(CurrentLang);
        this.onLocaleChange.Raise();
    }
}
export const ResourcesManager = new _ResourcesManager();
